import SelectroV2, { type SelectroV2Props } from '@aha-app/selectro-v2';
import React, { useRef } from 'react';

type MemoSelectroProps = Pick<
  SelectroV2Props,
  | 'deferFetch'
  | 'callbacks'
  | 'selected'
  | 'type'
  | 'functions'
  | 'deferFetch'
  | 'hideSearchBar'
  | 'fetchUrl'
  | 'branchesSelectable'
  | 'showClearAllButton'
  | 'className'
>;

// Wrapping Selectro in a memo here because it seems to mount/unmount its list items on every
// render, and we need to prevent that. This isn't ideal because memo isn't a guarantee, but
// solves the issue for now. Ideally Selectro would be more resilient to re-renders, but from
// a brief investigation it seems like an issue within the Virtuoso library.
const MemoSelectro = ({
  callbacks,
  functions,
  ...props
}: MemoSelectroProps) => {
  // any potentially unstable props need to be memoized here to avoid re-renders
  const memoCallbacks = useRef(callbacks);
  const memoFunctions = useRef(functions);

  return (
    <MemoSelectroInner
      callbacks={memoCallbacks.current}
      functions={memoFunctions.current}
      {...props}
    />
  );
};

const MemoSelectroInner = React.memo(function MemoSelectroInner(
  props: MemoSelectroProps
) {
  return (
    <SelectroV2
      {...props}
      isSingleTypeUnselectable={!!props.showClearAllButton}
    />
  );
});

export default MemoSelectro;
